import React, { useState } from 'react';
import { Layout, Menu, Button, Drawer, Grid, theme } from 'antd';
import { MenuOutlined, UserOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';

const { Header } = Layout;
const { useBreakpoint } = Grid;

const StickyNav = () => {
  const screens = useBreakpoint();
  const location = useLocation();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const {
    token: { colorPrimary },
  } = theme.useToken();

  // Menu items
const menuItems = [
  {
    key: '/dashboard',
    label: <Link to="/ui/dashboard" style={{ color: 'inherit' }}>Dashboard</Link>,
  },
  {
    key: '/track',
    label: 'Track',
    children: [
      { key: 'food', label: <Link to="/ui/dashboard" style={{ color: 'inherit' }}>Food</Link> },
      { key: '/goal', label: <Link to="/ui/goal" style={{ color: 'inherit' }}>Goals</Link> },
      { key: '/activity', label: <Link to="/ui/activity" style={{ color: 'inherit' }}>Activities</Link> },
      { key: '/weight', label: <Link to="/ui/weight" style={{ color: 'inherit' }}>Weight</Link> },
    ],
  },
  {
    key: '/recipe',
    label: <Link to="/ui/recipe/list" style={{ color: 'inherit' }}>Recipes</Link>,
    
  },
  {
    key: '/settings',
    label: <UserOutlined />,
    children: [
      { key: '/account', label: <Link to="/ui/account" style={{ color: 'inherit' }}>Account</Link> },
      { key: '/userattributes', label: <Link to="/ui/user/attributes" style={{ color: 'inherit' }}>User Attributes</Link> },
    ],
  },
];


  // Left vs right keys for desktop
  const leftMenuKeys = ['/dashboard','/track', '/recipe'];
  const rightMenuKeys = ['/settings'];

  // Desktop menu components (left and right)
  const DesktopMenu = () => (
    <Menu
      mode="horizontal"
      selectedKeys={[location.pathname]}
      style={{ flex: 1, background: 'transparent' }}
      theme="light"
      items={menuItems.filter(i => leftMenuKeys.includes(i.key))}
    />
  );

  const DesktopRightMenu = () => (
  <Menu
    mode="horizontal"
    selectedKeys={[location.pathname]}
    style={{ 
      marginLeft: 'auto', 
      background: 'transparent',
      minWidth: 0  // Force wider menu
    }}
    theme="light"
    overflowedIndicator={false}  // Disable dots entirely
    items={menuItems.filter(i => rightMenuKeys.includes(i.key))}
  />
);


  // Mobile menu rendered inside drawer, inline vertical style
  const MobileMenu = () => (
    <Menu
      mode="inline"
      selectedKeys={[location.pathname]}
      items={menuItems}
      theme="light"
      inlineIndent={24}
      onClick={() => setDrawerVisible(false)} // close drawer on menu click
      style={{ height: '100%', borderRight: 0 }}
    />
  );

  return (
    <Header
       style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingInline: 32,               // similar left/right padding
        height: 64,                      // adjust to match design
        background: 'rgba(255, 255, 255, 0.85)', // slightly transparent
        backdropFilter: 'blur(12px)',    // optional, for glassy effect
        WebkitBackdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(0,0,0,0.06)', // subtle divider
        boxShadow: '0 1px 0 rgba(0,0,0,0.03)',      // or a tiny shadow
      }}
    >
      {screens.md ? (
        <>
          <DesktopMenu />
          <DesktopRightMenu />
        </>
      ) : (
        <>
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: 24 }} />}
            onClick={() => setDrawerVisible(true)}
            aria-label="Open menu"
          />
          <Drawer
            title="Menu"
            placement="left"
            onClose={() => setDrawerVisible(false)}
            open={drawerVisible}
            bodyStyle={{ padding: 0 }}
          >
            <MobileMenu />
          </Drawer>
        </>
      )}
    </Header>
  );
};

export default StickyNav;
